import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'dtis-admin-landing-page',
  imports: [TranslocoModule, RouterModule],
  host: {
    class: 'flex flex-col h-full w-full',
  },
  template: `
    <div class="container mx-auto my-20 px-4">
      <div class="flex items-center justify-center">
        <div class="flex flex-col items-center gap-4 text-center">
          <h1 class="text-display-medium font-thin">
            {{ 'welcome-to-dtis-admin' | transloco }}
          </h1>
          <p class="text-title-medium mb-6">
            {{
              'manage-your-business-units-and-view-recent-activity-from-this-dashboard'
                | transloco
            }}
          </p>
          <a
            routerLink="/business-unit-management"
            class="bg-primary hover:bg-primary-dark mb-8 inline-block w-fit rounded-full px-6 py-3 font-semibold text-white shadow transition"
          >
            {{ 'go-to-business-unit-management' | transloco }}
          </a>
        </div>
      </div>
    </div>
  `,
})
export class LandingPageComponent {}
